import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getTaxiCopy } from './taxi-i18n';
import { TAXI_THEME } from './taxi-theme';
import TaxiLanguageSelector from './TaxiLanguageSelector';
import TaxiLogo from './TaxiLogo';

const DEMO_PASSWORD = TAXI_THEME.password;
const STORAGE_KEY = 'taxi_radenovic_auth';

async function sha256(text) {
  const data = new TextEncoder().encode(text);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

let cachedHash = null;

async function getPasswordHash() {
  if (!cachedHash) {
    cachedHash = await sha256(DEMO_PASSWORD);
  }
  return cachedHash;
}

export default function TaxiPasswordGate({ onUnlock }) {
  const { lang } = useParams();
  const copy = getTaxiCopy(lang);
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    async function checkStored() {
      const hash = await getPasswordHash();
      if (localStorage.getItem(STORAGE_KEY) === hash) {
        onUnlock();
      }
      setChecking(false);
    }
    checkStored();
  }, [onUnlock]);

  async function handleSubmit(e) {
    e.preventDefault();
    const hash = await getPasswordHash();
    const inputHash = await sha256(input.toLowerCase().trim());
    if (inputHash === hash) {
      localStorage.setItem(STORAGE_KEY, hash);
      setError(false);
      onUnlock();
    } else {
      setError(true);
    }
  }

  if (checking) {
    return (
      <div className="taxi-gate">
        <TaxiLanguageSelector label={copy.langLabel} />
        <div className="taxi-gate-card">{copy.gateLoading}</div>
      </div>
    );
  }

  return (
    <div className="taxi-gate">
      <TaxiLanguageSelector label={copy.langLabel} />
      <div className="taxi-gate-card">
        <TaxiLogo compact subtitle={copy.brandSubtitle} />
        <p className="taxi-gate-tagline">{copy.tagline}</p>
        <h1 className="taxi-gate-title">{copy.gateTitle}</h1>
        <p className="taxi-gate-sub">{copy.gateSub}</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            className="taxi-gate-input"
            placeholder={copy.gatePlaceholder}
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
              setError(false);
            }}
            autoFocus
            aria-label={copy.gatePlaceholder}
          />
          <button type="submit" className="taxi-gate-btn">
            {copy.gateEnter}
          </button>
        </form>
        {error && <p className="taxi-gate-error">{copy.gateError}</p>}
        <p className="taxi-gate-foot">{copy.gateFoot}</p>
      </div>
    </div>
  );
}
